import {FC} from "react";
import {Box, Typography} from "@mui/material";

interface InstructionsComponentProps {
	data: any;
}

export const InstructionsComponent: FC<InstructionsComponentProps> = ({data}) => {
	return (
		<Box sx={{
			width: '100%',
		}}>
			<Box sx={{
				minHeight: '478px',
				border: '1px solid rgba(1, 18, 36, 0.12)',
				display: 'flex',
				padding: '32px',
				flexDirection: 'column',
			}}>
				<Typography sx={{
					fontSize: '20px',
					fontWeight: 800,
					marginBottom: '16px',
				}}
				>
					Инструкция
				</Typography>
				
				<Typography sx={{
					fontSize: '16px',
					fontWeight: 600,
					marginBottom: '16px',
					
				}}
				>
					{data.instructions}
				</Typography>
			</Box>
		</Box>
	)
};